export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addStaff.vue?vue&type=template&id=5dfb43e9&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/addStaff.vue?vue&type=template&id=5dfb43e9&
// module id = 1357
// module chunks = 0